import server from "@/api/server";

/**
 * @typedef {Object} AttachmentAfterActionResponse
 * @property {Array} files
 * @property {string} files.id
 * @property {string} files.mime
 * @property {string} files.filename
 * @property {boolean} files.can_be_deleted
 */

/**
 *
 * @param uploadLink Ссылка после загрузки файла ({@link @/api/server/upload.js} uploadFile)
 * @param contextName Контекст вложения (заявка/профиль/встреча/представитель и пр.)
 * @param contextId ИД контекста
 * @param groupName Группа вложений
 * @param fileAlias Наименование вложения в группе (для обозначения типа файла вложения)
 * @param customFileName
 * @returns {Promise<AttachmentAfterActionResponse>}
 */
async function create(uploadLink, { contextName, contextId, groupName, fileAlias, fileName }) {
  return await server.post('agent/agent/attachment/create', {
    link: uploadLink,

    context_name: contextName,
    context_id: contextId,
    group_name: groupName,
    file_alias: fileAlias,
    custom_filename: fileName
  });
}

/**
 * @typedef {Object} AttachmentPrepareLinkResponse
 * @property {string} link base64 string
 * @property {Date} valid_to
 * @property {string} url.public
 */

/**
 *
 * @param {string} attachmentId
 * @returns {Promise<AttachmentPrepareLinkResponse>}
 */
async function prepareLink(attachmentId) {
  return await server.post('agent/agent/attachment/prepare-link', { id: attachmentId });
}

/**
 *
 * @param {string} attachmentId
 * @returns {Promise<AttachmentAfterActionResponse>}
 */
async function remove(attachmentId) {
  return await server.post('agent/agent/attachment/delete', { id: attachmentId });
}

export {
  create as attachmentCreate,
  remove as attachmentDelete,
  prepareLink as attachmentPrepareLink
}
